import { TabSwitcher } from "./TabSwitcher";

import {
	CloudUpload,
	SquarePen,
} from "lucide-react";


import { useNotes } from "../contexts/NotesContext"
import { Button } from '@/components/ui/button';
import { SmartNotesTab } from './SmartNotesTab';
import { formatDate } from "date-fns";
import { TranscribeButton } from "./TranscribeButton";
import { TranscriptTab } from "./TranscriptTab";
import { NoteEditorTab } from "./NoteEditorTab";


const NoteHeader = () => {
	const { noteId, notesMetadata, activeCourse, handleMetadataChange, isSaving } = useNotes();

	if (!noteId) return null;

	const noteMetadata = notesMetadata?.[activeCourse]?.find((note: any) => note.id === noteId) ?? null;

	if (!noteMetadata) return <p>unknown note id</p>;

	return (
		<div className="pt-[20px] pb-[10px]">
			<div className="flex items-center gap-[7px]">
				<p className="text-sm font-medium text-theme-1">{formatDate(noteMetadata?.modified_at, "MMM d, yyyy")}</p>
				<div className={`text-sm font-medium text-theme-1 transition-opacity duration-200 ${isSaving ? "opacity-100" : "opacity-33"}`}>
					<CloudUpload className="w-[13px] h-[13px] text-theme-1" />
				</div>

			</div>
			<input
				type="text"
				className="text-2xl font-bold border-0 mt-[5px] w-full"
				value={noteMetadata?.title}
				onChange={(e) => handleMetadataChange({ title: e.target.value })}
			/>
		</div>
	)
}

const TabContent = () => {
	const { activeTab } = useNotes();

	const tabContentVariants = {
		hidden: { opacity: 0 },
		visible: { opacity: 1, transition: { duration: .2 } },
		exit: { opacity: 0, transition: { duration: .2 } },
	};

	if (activeTab === "notes") return <NoteEditorTab />;
	if (activeTab === "transcript") return <TranscriptTab />;
	if (activeTab === "ai") return <SmartNotesTab />;

}

export const ContentLayout = () => {

	const { noteId } = useNotes();

	if (!noteId) return <NoSelectedNote />

	return (
		<div className="flex-1 px-[20px] pb-[30px] relative flex flex-col min-h-0">
			<NoteHeader />
			<TabSwitcher />
			<TabContent />
			<TranscribeButton />
		</div>
	)
}

const NoSelectedNote = () => {

	const { handleNewNote } = useNotes();

	return (
		<div className="flex justify-center items-center h-full w-full">
			<Button variant="default" onClick={handleNewNote} className="flex items-center gap-[10px] rounded-lg">
				<SquarePen className="w-[20px] h-[20px]" />
				<span>New note</span>
			</Button>
		</div>
	)
}